import { postData } from "../../../services/api.service";

const verifyEmail = async (data) => {
  const route = `/user_forgot_password`;
  return await postData(route, data);
};

const verifyCode = async (recovery_code, email) => {
  const route = `/user_verification_code`;
  return await postData(route, { recovery_code, email });
};

const changePassword = async (newPassword, email) => {
  const route = `/validate_user_change_forgot_pass`;
  return await postData(route, { newPassword, email });
};

const emailRecuperationService = {
  verifyEmail,
  verifyCode,
  changePassword,
};

export default emailRecuperationService;
